<template>
    <v-container colum fluid fill-height v-if="warehouseId">
        <v-row>
            <v-col>
                <v-btn text to="/inventory/warehouse">
                    <v-icon left>mdi-arrow-left</v-icon>Back
                </v-btn>
                <v-card>
                    <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-package-variant-closed</v-icon>Location
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <AddWarehouseLocation :warehouseId="warehouseId" @added="getList" />
                    </v-toolbar-items>
                    </v-toolbar>
                    <v-data-table
                        :headers="headers"
                        :items="list"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="totalCount"
                        >
                        <template v-slot:item.actions="{item}">
                            <EditWarehouseLocation :location="item" @saved="getList" />
                            <DeleteWarehouseLocation :location="item" @saved="getList" />
                        </template>
                        <template v-slot:item.container="{item}">
                            {{item.container ? 'Yes':'No'}}
                        </template>

                        <template v-slot:item.backstockLocation="{item}">
                            {{item.backstockLocation ? 'Yes':'No'}}
                        </template>

                        <template v-slot:item.reserveLocation="{item}">
                          {{item.reserveLocation ? 'Yes':'No'}}
                        </template>

                        <template v-slot:item.default="{item}">
                          {{item.default ? 'Yes':'No'}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import AddWarehouseLocation from '@components/warehouseLocation/Add'
import EditWarehouseLocation from '@components/warehouseLocation/Edit'
import DeleteWarehouseLocation from '@components/warehouseLocation/Delete'
export default {
    components:{
        AddWarehouseLocation,
        EditWarehouseLocation,
        DeleteWarehouseLocation
    },
    data: () => ({
        list:[],
        loading:true,
        headers: [
            { text: "Location", value: "location", align: "left" },
            { text: "Parent", value: "parent.location", align: "left" },
            { text: "Container", value: "container" },
            { text: "Backstock", value: "backstockLocation" },
            { text: "Reserve", value: "reserveLocation" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        options: { itemsPerPage: 20 },
        totalCount:0,
        warehouseId:null
    }),
    mounted(){
        if (this.$route.params.id) {
            this.warehouseId = parseInt(this.$route.params.id);
            this.getList()
        } else {
            this.$route.push("/clients");
        }
    },
    watch:{
        options:function(){
            this.getList()
        }
    },
    methods:{
        ...mapActions("warehouseLocation", {listWarehouse:"list"}),
        getList(){
            this.listWarehouse({
                pagination: this.options,
                rows_per_page: this.options.rowsPerPage,
                search: this.search,
                filters: {
                    warehouse_id:this.warehouseId
                },
                
            })
            .then(({locations}) => {
                this.list = locations.data
                this.totalCount=locations.total
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
    
}
</script>

<style>

</style>